'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var urlize = function urlize(str) {
    return str.toLowerCase().replace(/æ/g, 'ae').replace(/ø/g, 'o').replace(/å/g, 'a').replace(/\W+/g, '-');
};

var Tags = function Tags(_ref) {
    var theme = _ref.theme,
        tags = _ref.tags,
        listHeading = _ref.listHeading,
        listAriaHeading = _ref.listAriaHeading;

    if (tags.length === 0) {
        return null;
    }

    var tagList = tags.map(function (tag) {
        var urlParts = [tag.type === 'Story' ? 'emne' : 'tag', tag.id, urlize(tag.title)];

        return _react2.default.createElement(
            'li',
            { key: tag.id },
            _react2.default.createElement(
                'a',
                { href: '/' + urlParts.map(encodeURIComponent).join('/') },
                tag.title
            )
        );
    });

    return _react2.default.createElement(
        'section',
        { className: theme.tags },
        listHeading.length > 0 && _react2.default.createElement(
            'h2',
            null,
            listHeading
        ),
        _react2.default.createElement(
            'ul',
            { 'aria-label': listAriaHeading },
            tagList
        )
    );
};

Tags.defaultProps = {
    listAriaHeading: '',
    listHeading: ''
};

Tags.propTypes = {
    listAriaHeading: _propTypes2.default.string,
    listHeading: _propTypes2.default.string,
    theme: _propTypes2.default.shape({
        'tags-wrapper': _propTypes2.default.string
    }).isRequired,
    tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired,
        type: _propTypes2.default.string.isRequired,
        title: _propTypes2.default.string.isRequired
    })).isRequired
};

exports.default = Tags;
//# sourceMappingURL=Tags.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/tags/lib/cjs/Tags.js
 ** module id = 742
 ** module chunks = 1
 **/